// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__YWOtr","tab":"Tabs_tab__1TDp4","tabActive":"Tabs_tabActive__3Iieg"};